module.exports = __webpack_public_path__ + "static/media/tutorial_confirm.8c863824.png";